import { InAppReview } from "@capacitor-community/in-app-review";
import { getPlatform, isNativeApp } from "@/models/platform";
import { Share } from "@capacitor/share";
import type { Book } from "@/models/types";
import { useUserSlice } from "@/models/useUserSlice";
import { i18n } from "@/locales";
import { logFunnelEvent } from "@/fetchData/datadog";

export const ANDROID_APP_LINK =
  "https://play.google.com/store/apps/details?id=com.dktlabs.eznoteai";

export const IOS_APP_LINK =
  "https://apps.apple.com/us/app/eznote-ai-note-taker/id6741395895";

export const requestReview = () => {
  if (isNativeApp()) {
    InAppReview.requestReview();
  }
};

export const shareApp = async () => {
  const platform = getPlatform();

  if (platform === "android") {
    Share.share({
      title: "Download PurelyNovels",
      text: "Unlimited novels. No coins. No waiting. Download PurelyNovels now!",
      url: ANDROID_APP_LINK,
    });
    return;
  }

  if (platform === "ios") {
    Share.share({
      title: "Download PurelyNovels",
      text: "Unlimited novels. No coins. No waiting. Download PurelyNovels now!",
      url: IOS_APP_LINK,
    });
    return;
  }

  // Web: use Web Share API if available, otherwise open link
  if (navigator.share) {
    try {
      await navigator.share({
        title: "PurelyNovels",
        text: "Unlimited novels. No coins. No waiting.",
        url: window.location.origin,
      });
    } catch {
      // user cancelled or share failed
    }
  } else {
    window.open(ANDROID_APP_LINK, "_blank");
  }
};

export const shareBook = async (book: Book) => {
  const lang = useUserSlice.getState().contentLanguage;
  const url = `https://purelynovels.com/web?bookId=${book.bookId}&contentLang=${lang}`;
  const text = i18n.t("home.shareText", { title: book.aiTitle });
  logFunnelEvent("share:book_shared", { bookId: book.bookId });

  if (isNativeApp()) {
    await Share.share({ title: book.aiTitle, text, url });
    return;
  }

  if (navigator.share) {
    try {
      await navigator.share({ title: book.aiTitle, text, url });
    } catch {
      // user cancelled
    }
  } else {
    await navigator.clipboard.writeText(`${text}\n${url}`);
  }
};
